module.exports = __webpack_public_path__ + "static/media/lab.1f2de883.svg";